<template>
  <div class="platform-info-edit-wrp ft-12">
    <el-form
      class="form"
      :model="self_form"
      :rules="rules"
      ref="form"
      label-width="12%"
    >
      <slot name="errMsg"></slot>
      <section>
        <div class="title ft-12">
          <span>类目选择</span>
        </div>
        <div class="conf">
          <el-form-item label="商品分类:" prop="categoryIds">
            <div class="category ft-12">
              <category-input ref="cinput" v-model="self_form.categoryIds" :isSupportAi="true" :platform="platform" :baseItemId="baseItemId" />
            </div>
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title ft-12">
          <span>基本信息</span>
        </div>
        <div class="conf">
          <el-form-item label="引用套图:" v-if="showGroupImages">
              <div class="ft-12">商品资料已维护套图，电商平台图片可以使用已维护套图快速填充 <el-link @click="editGroupImages">维护套图</el-link> </div>
              <GroupImagesList :baseItemId="baseItemId" :specifications="specifications" @useOk="useGroupImages" @getList="getGroupImagesList"></GroupImagesList>
          </el-form-item>
          <el-form-item label="商品主图" prop="imageUrls">
            <div class="imgs-wrp">
              <div class="ft-12">展示时只取主图，拖动可调整顺序<BatchEditImages v-model="self_form.imageUrls" refName="imageUrls" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages></div>
              <MutiImgUpload
                ref="imageUrls"
                v-model="self_form.imageUrls"
                :key="JSON.stringify(autoCropImageConfigList)"
                :limitSize="isCheckMainImg ? 2 * 1024 * 1024 : 0"
                :limitNums="9"
                :limitHeight="isCheckMainImg ? [600, 0] : [0,0]"
                :limitWidth="isCheckMainImg ? [600, 0] : [0,0]"
                :aspectRatio="isCheckMainImg ? 1 : 0"
                :aspectRatioText="isCheckMainImg ? '1:1' : ''"
                :size="100"
                limitSuffix=".jpg,.png,.jpeg,.webp,.bmp"
                :supportAiRetry="true"
                :autoCropImageParams="{publishAutoCropImageEnum:'KUAISHOU_MainImg'}"
              />
              <!-- <div class="tips" style="color: #F56C6C;font-size: 14px;">
                <span
                  >注意：快手平台所有图片都必须为jpg格式</span
                >
              </div> -->
            </div>
          </el-form-item>
          <el-form-item>
            <p class="tips ft-12">
              1. 请使用png/jpg/jpeg/webp/bmp格式，单图大小需小于2M，图片需满足1:1<br />
              2. 支持批量传图，最多上传9张图片<br />
            </p>
          </el-form-item>
          <el-form-item label="主图3:4:" prop="mainImages34" style="margin-bottom: 0px;">
            <template slot="label">
                主图3:4
                <el-tooltip effect="dark" content="3:4主图将在商详及商城猜你喜欢场景露出展示，预估最高可提升3%商品点击率，有机会获得更多流量提升转化。" placement="top-start">
                    <i style="font-size: 14px;" class="el-icon-Group-14"></i>
                </el-tooltip>
            </template>
            <div><BatchEditImages v-model="self_form.mainImages34" refName="mainImages34" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages></div>
            <div class="imgs-wrp">
                <MutiImgUpload
                    v-model="self_form.mainImages34"
                    ref="mainImages34"
                    :key="JSON.stringify(autoCropImageConfigList)"
                    :mainImgNums="0" 
                    limitSuffix=".jpg,.jpeg,.png" 
                    :limitNums="5"
                    :limitWidth="isCheckMainImg34 ? [600, 5000] : [0,0]"
                    :limitHeight="isCheckMainImg34 ? [600, 5000] : [0,0]"
                    :limitSize="isCheckMainImg34 ? 2 * 1024 * 1024 : 0"
                    :cropDefaultSize="[750, 1000]"
                    :aspectRatio="isCheckMainImg34 ? [0.75] : 0"
                    :aspectRatioText="isCheckMainImg34 ? '3:4' : ''"
                    :autoCropImageParams="{publishAutoCropImageEnum:'KUAISHOU_MainImg34'}"
                />
            </div>
        </el-form-item>
        <el-form-item>
          <p class="tips ft-12">
              1.图片长宽比为3:4，大小不超过2M，单边像素不少于600px、不超过5000px，支持jpg/jpeg/png格式
          </p>
        </el-form-item>
          <el-form-item label="商品名称" prop="title">
            <el-input
              type="text"
              placeholder="请输入"
              v-model="self_form.title"
            >
              <span slot="suffix" style="margin-right: 6px;">{{titleLength}}/60</span>
            </el-input>
          </el-form-item>
          <el-form-item label="商品短标题" prop="shortTitle">
            <el-input v-model="self_form.shortTitle" placeholder="请输入" >
              <span slot="suffix" style="margin-right: 6px;">{{shortTitleLength}}/20</span>
            </el-input>
          </el-form-item>
          <el-form-item
              v-if="categoryId"
              label="品牌" prop="brandId">
              <BrandIdBlock
                  ref="BrandIdBlockRef"
                  v-model="self_form.shopBrandConf"
                  :shopList="shopList" 
                  :baseItemId="baseItemId"
                  :categoryId="categoryId"
                  />
          </el-form-item>
          <el-form-item label="商品属性">
            <UseCategoryTemplate :detailHasCategory="detailHasCategory" :detailId="self_form.id" :baseItemId="baseItemId" :categoryIds.sync="self_form.categoryIds" :platform="platform" :propValues="self_form.itemPropValues" @clickFill="clickTemPlateFill">
              <CategoryProps
                ref="cateprops"
                v-model="self_form.itemPropValues"
                :categoryIds="self_form.categoryIds"
                :baseItemId="baseItemId"
                @refundRuleChange="updateRefundRule"/>
            </UseCategoryTemplate>
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title">
          <span>商品详情</span>
        </div>
        <div class="conf">
          <el-form-item label="商品描述" prop="details">
            <el-input
              type="textarea"
              placeholder="请输入"
              v-model="self_form.details"
            >
            </el-input>
            <div class="tips ft-12">
              <span>未填写时系统默认使用商品名称！</span>
            </div>
          </el-form-item>
          <el-form-item label="商品详情图:" prop="detailImageUrls">
            <div><BatchEditImages v-model="self_form.detailImageUrls" refName="detailImageUrls" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages></div>
            <div class="imgs-wrp">
              <MutiImgUpload
                ref="detailImageUrls"
                :key="JSON.stringify(autoCropImageConfigList)"
                :limitSize="isCheckDesc ? 2 * 1024 * 1024 : 0"
                v-model="self_form.detailImageUrls"
                :mainImgNums="0"
                :limitNums="50"
                :size="100"
                limitSuffix=".jpg,.jpeg,.png,.webp,.bmp" 
                :supportAiRetry="true"
                :autoCropImageParams="{publishAutoCropImageEnum:'KUAISHOU_Desc'}"
              />
            </div>
          </el-form-item>
          <el-form-item>
            <p class="tips ft-12">
              单图大小需小于2M，最多上传50张图片
            </p>
          </el-form-item>
            <el-form-item label="白底图" prop="whiteBaseImageUrl">
              <MutiImgUpload
                ref="whiteBaseImageUrl"
                :mainImgNums="0"
                :limitNums="1"
                :limitWidth="isCheckWhiteImg ? [480, 0] : [0, 0]" 
                :limitHeight="isCheckWhiteImg ? [480, 0] : [0, 0]" 
                :limitSize="isCheckWhiteImg ? 2 * 1024 * 1024 : 0" 
                limitSuffix=".jpg,.jpeg,.png" 
                :aspectRatio="isCheckWhiteImg ? [1] : 0"
                :cropDefaultSize="[800, 800]"
                :aspectRatioText="isCheckWhiteImg ? '1:1' : ''"
                :size="100"
                v-model="self_form.whiteBaseImageUrl" 
                :autoCropImageParams="{targetWidth:480,targetHeight:480}"
              />
            </el-form-item>
            <el-form-item>
                <p class="tips ft-12">
                    1. 有白底图的商品会被优先推荐，获得更多曝光机会！<br />
                    2. 白底图必须白背景。图片长宽比为1:1的图片，像素480*480px以上的图片，大小不超过2M，支持jpg/jpeg/png<br />
                </p>
            </el-form-item>
          <el-form-item label="商品视频">
            <div class="imgs-wrp">
              <!-- 视频组件 -->
              <el-row style="display: flex; align-items: center;">
                <VideoUpload
                  style="text-align: left;"
                  @upload-success="v => handleVideo(v, 1)"
                  :video="self_form.videoVo"
                  aspectRatio="1:1,3:4,4:3,9:16,16:9"
                  limitSuffix=".mp4"
                  :limitWidth="[600, 0]"
                  :limitHeight="[600, 0]"
                  @del="v => handleVideo(v, 0)"
                  :limitDuration="90"
                  :companyId="userInfo.companyId"
                />
              </el-row>
              <div class="tips ft-12">
                <span>1. 推荐使用mp4格式上传，视频大小支持1KB-200MB，视频宽高比支持1:1、3:4、4:3、9:16、16:9，宽度和高度单边像素至少大于600</span>
                <span>2. 支持3秒-90秒的视频，注意避免过短或过长，简洁明了地展示商品特点</span>
              </div>
            </div>
          </el-form-item>
        </div>
      </section>
      <section>
        <div class="title">
          <span>规格与库存</span>
        </div>
        <div class="conf">
          <el-form-item label="发货时效模式:">
            <div class="tips ft-12"> 请按实际情况合理设置发货时效，并及时发货，设置规则及常见问题查看 
              <a href="https://university.kwaixiaodian.com/kwaishop/newKnowledge/588436841423568900/581287785622441994" target="_blank">《发货规则及设置指南》</a>
            </div>
            <el-radio-group v-model="self_form.sellType" @change="changeSell_type">
              <el-radio :label="1">
                全部现货   
              </el-radio>
              <el-tooltip popper-width="200px" effect="dark" content="推荐使用现货功能，提升店铺分获得流量加权，促使用户下单转化，降低用户发货前退款率" placement="top">
                  <i class="el-icon-bangzhuzhongxin icon-tip"></i>
              </el-tooltip>
              <el-radio :label="2">全部预售</el-radio>
              <el-radio :label="3">现货+预售  <a href="https://university.kwaixiaodian.com/kwaishop/knowledge/1655" target="_blank">查看《现货+预售使用指南》</a> </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="现货承诺发货时间:" v-if="[1, 3].includes(self_form.sellType)" prop="sellTimeConfig.spotGoodsTime">
            <el-radio-group v-model="self_form.sellTimeConfig.spotGoodsTime">
              <el-radio :label="null" v-if="self_form.sellType === 3">无现货</el-radio>
              <el-radio :label="86400">24小时</el-radio>
              <el-radio :label="172800">48小时</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="预售发货时间:" v-if="[2, 3].includes(self_form.sellType)" prop="sellTimeConfig.presellTime" style="font-size: 12px;">
            <span style="margin-right: 20px;" v-for="(pre, preIndex) in self_form.sellTimeConfig.presellTime" :key="preIndex">
              付款后<el-input-number
                style="width: 100px; margin:0 8px"
                v-model="self_form.sellTimeConfig.presellTime[preIndex]"
                :min="3"
                :max="15"
                :step="0"
                :precision="0"
                :controls="false"
                placeholder="范围3-15天"
                />天内发货
              <el-link style="color: red;" v-if="self_form.sellTimeConfig.presellTime.length >= 2 && self_form.sellType === 3" type="text" @click="deletePresellTime(preIndex)"><i class="el-icon-error"></i></el-link>
            </span>
            <el-button v-if="self_form.sellTimeConfig.presellTime.length < 2 && self_form.sellType === 3" type="text" @click="addPresellTime">+添加发货时效</el-button>
          </el-form-item>
          <el-form-item label="商品规格:" prop="skuAttrs">
            <RuleSortBtn :specifications.sync="specifications" />
            <SpecsValuesSort :specifications.sync="specifications" />
            <FormItemSpecification
              ref="specificationRef"
              v-model="specifications"
              :changeToBase="changeToBase"
              :isCheckImg="isCheckSkuImg"
              @fieldChanged="specificationsFieldChanged"
            />
          </el-form-item>
          <el-form-item label="规格明细:" prop="skuAttrsDetail">
            <FormItemSkuList
              :isKuaiShou="true"
              :baseItemId="baseItemId"
              :uploadSpecImg="specification_needImg"
              @specification-upload-img="specificationUploadImg"
              :specifications="specifications"
              skuSpecificationsKey="skuSpecifications1"
              :imgOnlyPreview="skuImgOnlyPreview"
              :tableCols="skuTableCols"
              v-model="skuList"
              @fieldChanged="specificationsFieldChanged"/>
              <template v-if="specificationsValidResult !== true">
                <div class="el-form-item__error">{{specificationsValidResult}}</div>
              </template>
          </el-form-item>

        </div>
      </section>
      <section>
        <div class="title">
          <span>其他设置</span>
        </div>
        <div class="conf">
          <el-form-item label="商品限购:" prop="purchaseLimit">
            <el-switch
              v-model="self_form.purchaseLimit"
              :active-value="1"
              :inactive-value="0">
            </el-switch>
          </el-form-item>
          <el-form-item v-if="self_form.purchaseLimit" label="限购数量:" prop="limitCount">
            <el-input-number
              style="width:60px;margin-right:8px"
              v-model.number="self_form.limitCount"
              :controls="false"
              :min="1"
              :precision="0"
              :max="98"
              />
            件
          </el-form-item>
          <el-form-item label="保证金:" prop="depositRule">
            <el-select v-model="self_form.depositRule" placeholder="请选择">
              <el-option
                v-for="item in [{label: '已交', value: 2},{label: '未交', value: 1}]"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="退货类型:"
            prop="refundRule">
            <el-select v-model="self_form.refundRule" placeholder="请选择">
              <el-option
                v-for="item in refundRuleOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="服务承诺:">
            <el-checkbox v-for="promise in servicePromiseSelectList" :key="promise.key" v-model="self_form.servicePromise[promise.key]" :disabled="promise.disabled">{{ promise.label }}</el-checkbox>
          </el-form-item>
        </div>
      </section>
       <!-- 运费模板 -->
      <section>
        <div class="title ft-12">
          <span>运费模板</span>
        </div>
        <div class="conf">
          <el-form-item label="运费设置：">
            <el-row v-if="shopList.length && shipsValue">
              <el-col v-for="shop in shopList" :key="shop.id" :span="12" class="set-ship">
                <el-image
                  :src="shop.icon"
                  style="width: 26px; height: 26px;  border-radius: 50%"
                  ></el-image>
                <el-tooltip v-if="shop.channelIcon" :content="shop.channelName" style="margin: 0px -6px 0px 6px;">
                  <el-image :src="shop.channelIcon" style="width: 18px; height: 18px;"></el-image>
                </el-tooltip>
                <span class="shop-title">{{ shop.shortTitle || shop.title}}</span>
                <el-select 
                  v-model="shipsValue[shop.id]" 
                  placeholder="请选择运费模板"
                  :value-key="String(shop.id)"
                  clearable
                  @visible-change="changeSelect(shop.id, shop.userId)"
                  >
                  <el-option
                    v-for="ship in shipsTemplate[shop.id]"
                    :key="ship.id"
                    :label="ship.name"
                    :value="ship.id"
                    >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <span v-else class="no-shops">暂无平台店铺</span>
          </el-form-item>
        </div>
      </section>
      <!-- 上架设置 -->
      <section>
        <div class="title ft-12">
          <span>上架设置</span>
        </div>
        <div class="conf">
          <el-form-item 
            label="上架设置:" 
            :rules="[{required: true, message: '请输入上架设置', trigger: 'blur'}]">
              <el-radio-group v-model="isOnshelf">
                  <el-radio :label="1">立即上架</el-radio>
                  <el-radio :label="2">放入草稿箱</el-radio>
              </el-radio-group>
          </el-form-item>
        </div>
      </section>
    </el-form>
  </div>
</template>
<script>
import "@/assets/css/prod.scss";
import MutiImgUpload from "@/components/Uploads/MutiImgUpload";
import FormItemSpecification from './FormItemSpecification.vue';
import BatchEditImages from '@/components/prod/center/components/BatchEditImages.vue'
import GroupImagesList from '@/components/prod/center/BasicComps/GroupImages/list.vue'
import CategoryProps from './CategoryProps.vue'
import CategoryInput from "../PlatformCategoryInput/index.vue";
import ReuseLastCategory from "../PlatformCategoryInput/ReuseLastCategory.vue";
import UseCategoryTemplate from '../UseCategoryTemplate.vue'
import BrandIdBlock from "./BrandIdBlock.vue";

import RULES from "./rules.js";
import {validateSkuPrice} from './rules';

import {specification_mixin} from '../FormItemSpecification'
import {refundRuleList} from './dictionary'
import { getSalePropRule } from '@/servers/prod/center/kuaishou.js'
import {getDistributionConfig, getKSTemplateList} from '@servers/prod/conf/index.js'
import {mapGetters} from 'vuex';
import validateMixin from '../validateMixin';
import shopListMixin from '../shopListMixin';
import { getBytesCount } from "@utils/data"
import { cloneDeep, isEmpty } from 'lodash';
import VideoUpload from '@/components/Uploads/videoUpload'
import { editKuaishouCarouselVideo } from "@/api/prod/center";

export default {
  mixins: [specification_mixin, validateMixin, shopListMixin],
  inject: {
    isGroupPuhuo: { default: false },
  },
  provide(){
    return {
      platform: "kuaishou",
      openSource:this.openSource
    }
  },
  components: {
    MutiImgUpload,
    BatchEditImages,
    GroupImagesList,
    CategoryInput,
    FormItemSpecification,
    CategoryProps,
    ReuseLastCategory,
    UseCategoryTemplate,
    BrandIdBlock,
    VideoUpload,
  },
  props: {
    form: {
      type: Object,
      default() {
        return {}
      }
    },
    shopsList: {
      type: Array,
      default: ()=> {
        return []
      }
    },
    baseItemId: [Number, String],
    changeToBase: Function,
    rowData: {
      type: Object,
      default: () => ({})
    },
    openSource:{
      type:String,
      default:''
    },
  },
  data() {
    return {
      platform: 'kuaishou',
      categoryId: '',
      showGroupImages: true,
      self_form: {
        sellTimeConfig: {
          spotGoodsTime: 172800,
          presellTime: ['']
        }
      },
      rules: RULES(this),
      isOnshelf: 1,
      skuTableCols: [],
      specImgLimits: {
        aspectRatio: 1,
        aspectRatioText: '1:1',
        limitSuffix: '.png,.jpg,.jpeg',
        limitSize: 2 * 1024 * 1024
      },
      categoryConfig: {},
      brandPropConfig: null,
      refundRuleOptions: [],
      servicePromiseSelectList: [],
      skuSpecificationsKey: 'skuSpecifications1',
      skuImgOnlyPreview: true, // sku的预览图是否只能预览不能编辑
      specification_needImg: true, // 规格需要校验图片是否补充
      shipsTemplate: null, // 运费模板列表
      shipsValue: null, // 运费模板值
      templateConfigMap: null, // 初始值
      originalTemplateConfig: null,
      originalShopBrandConf: null, // 原始品牌配置（用于保存时恢复未显示店铺的数据）
      isKuaishou: true,
      detailCategoryId: '',
      detailCategoryIdChange: false,
      autoCropImageConfigList:[],
      detailHasCategory: []
    };
  },
  watch: {
    'self_form.categoryIds': {
      handler(v) {
          if(v && v.length) {
            this.categoryId = v[v.length - 1]
            this.getSpecificationRules()
            if((this.detailCategoryId != this.categoryId) || this.detailCategoryIdChange){
              this.detailCategoryIdChange = true
                this.$nextTick(() => {
                    this.$refs.BrandIdBlockRef?.useBrandConfInit();
                });
            }
          }
      },
      immediate: true
    },
    form: {
      handler(v) {
        if(v.templateConfig && v.templateConfig.length) {
            this.originalTemplateConfig = cloneDeep(v.templateConfig);
        }
        // 保存原始 shopBrandConf，用于保存时恢复未显示店铺的数据
        if (v.shopBrandConf && v.shopBrandConf.length) {
            this.originalShopBrandConf = cloneDeep(v.shopBrandConf);
        }
        if(isEmpty(v)) return
        this.specification_needImg = v.uploadSpecImg;

        let sellTimeConfig = {
          spotGoodsTime: 172800,
          presellTime: ['']
        }
        if(v.sellTimeConfig) {
          const parseSellTimeConfig = JSON.parse(v.sellTimeConfig)
          let presellTime = []
          if(parseSellTimeConfig.presellTime?.length) {
            presellTime = parseSellTimeConfig.presellTime.map(time => (time || 0) / 24 / 3600 ) // 转换为天
          } else {
            presellTime = ['']
          }
          sellTimeConfig = { ...parseSellTimeConfig, presellTime }
          if(sellTimeConfig.spotGoodsTime === undefined){
            // 没有返回这个字段时，默认选中无现货
            sellTimeConfig.spotGoodsTime = null
          }
        } 
        this.detailHasCategory = v.categoryIds
        this.detailCategoryId = v.categoryIds ? v.categoryIds[v.categoryIds.length - 1] : '';
        this.$set(this, 'self_form', {
          ...v,
          sellType: v.sellType || 1,
          whiteBaseImageUrl: v.whiteBaseImageUrl || [],
          sellTimeConfig
        })
      },
      immediate: true
    },
    spotPresaleList: {
      handler(v) {
        this.createSkuListBySpecs()
        this.skuTableCols.forEach(col => {
          if(col.prop === 'spotPresaleName') {
            col.unvisible = !v.length
            return
          }
        })
      },
      deep: true
    },
  },
  computed: {
    ...mapGetters(['shops_getCategoryPropShopId', 'userInfo']),
    shopList() {
      let list = this.getShopList('kuaishou');
      if(this.openSource === 'shopGoods'){
          list = list.filter(item => item.id == this.form.shopId)
      }
      return list;
    },
    titleLength() {
      const goodsName = this.self_form.title || '';
      return getBytesCount(goodsName);
    },
    shortTitleLength() {
      const shortTitle = this.self_form.shortTitle || '';
      return getBytesCount(shortTitle);
    },
    // 现货 + 预售 参与规格笛卡尔积的值
    spotPresaleList() {
      let list = []
      let { sellType, sellTimeConfig: { spotGoodsTime, presellTime } } = this.self_form;
      presellTime = presellTime.filter(Boolean)
      if(sellType === 3 && (spotGoodsTime || spotGoodsTime == null) && presellTime) {
        if(spotGoodsTime){
          let spotGoodsDay = spotGoodsTime / 60 / 60 + '小时内发货';
          list.push(spotGoodsDay)
        }
        presellTime.forEach(day => {
          list.push(day + '天内发货')
        })
      }
      return list
    },
    isCheckMainImg(){
        return this.isCheckImg('mainImg')
    },
    isCheckMainImg34(){
        return this.isCheckImg('mainImg34')
    },
    isCheckDesc(){
        return this.isCheckImg('desc')
    },
    isCheckSkuImg(){
        return this.isCheckImg('skuImg')
    },
    isCheckWhiteImg(){
        return this.isCheckImg('whiteImg')
    },
  },
  methods: {
    isCheckImg(type){
        return !this.autoCropImageConfigList.includes(type);
    },
    getWidthAndHeights(refName) {
      return this.$refs[refName].getWidthAndHeights ? this.$refs[refName].getWidthAndHeights() : []
    },
   async getSpecificationRules() {
      const salePropRules = await getSalePropRule({
        shopId: this.shops_getCategoryPropShopId('kuaishou'),
        categoryId: this.categoryId
      })
      const specifications = this.getSpecifications(salePropRules)
      this.initSelfFormSkuList(specifications)
      this.specifications = specifications
    },
    getSpecifications(salePropRules) {
      const oriSpecifications = cloneDeep(this.self_form.specifications)
      // customSalePropConfigRule 自定义销售属性项-属性项规则, customSalePropValueConfigRule: 自定义销售属性项-属性值规则, presetSaleProp 预设销售属项规则
      const { customSalePropConfigRule, customSalePropValueConfigRule } = salePropRules;
      const { customSalePropNameConfigRule } = customSalePropConfigRule || {}
      const presetSaleProp = cloneDeep(salePropRules.presetSaleProp || [])
      const specNames = new Set(oriSpecifications.map(s => s.name));
      const specs = [];

      oriSpecifications.forEach(s => {
        // 先根据name精确匹配，在模糊匹配
        let findPropIndex = presetSaleProp.findIndex(presetItem => {
          const propName = presetItem.propName
          return propName === s.name || propName.includes(s.name) || s.name.includes(propName)
        });
        // 如果没有匹配到，则把必填的销售规则加上去
        if (findPropIndex === -1) {
          findPropIndex = presetSaleProp.findIndex(presetItem => {
            const { salePropConfigRule, propName } = presetItem
            const { required } = salePropConfigRule || {}
            return required && !Array.from(specNames).some(sn => sn.includes(propName) || propName.includes(sn))
          });
        }
        if (findPropIndex > -1) {
          const presetItem = presetSaleProp[findPropIndex];
          specs.push(this.getPresetSpec(presetItem, s));
          presetSaleProp.splice(findPropIndex, 1);
        } else {
          const valueConfigRule = customSalePropValueConfigRule || {}
          let specItem = {
            ...s,
            salePropType: 'custom',
            nameConfigRule: customSalePropNameConfigRule || {},
            valueConfigRule,
          }
          specItem.values.forEach(v => {
            v.extendValues = this.getDefaultExtendValues(valueConfigRule, v);
          })
          specs.push(specItem)
        } 
      })
      const findRequiredItem = presetSaleProp.find(presetItem => presetItem?.salePropConfigRule?.required)
      if(findRequiredItem) {
        specs.push(this.getPresetSpec(findRequiredItem))
      }
      return specs
    },
    getPresetSpec(presetItem, s = {}) {
      const { salePropConfigRule, propName, propId, customSalePropValueConfigRule, presetSalePropValueConfigRule } = presetItem
      const { required, supportCustomPropValue } = salePropConfigRule || {}
      const valueConfigRule = supportCustomPropValue ? customSalePropValueConfigRule : presetSalePropValueConfigRule

      const spec = {
        name: required ? propName : s.name,
        nameKey: s.nameKey || propName,
        salePropType: 'preset',
        nameConfigRule: { required },
        valueConfigRule,
        values: s.values?.length ? s.values.map((propV, idx) => {
          return {
            ...propV,
            propId,
            name: required ? propName : s.name,
            extendValues: this.getDefaultExtendValues(valueConfigRule, propV)
          };
        }) : [this.generateNewSpec(presetItem)]
      }; 
      return spec     
    },
    generateNewSpec(item) {
      return {
          checked: true,
          extendValues: {},
          value: '无规格',
          valueKey: '',
          name: item.propName,
          nameKey: item.propName,
          note: '',
          propId: item.propId,
          propValueId: ''
      }
    },
    getDefaultExtendValues(valueConfigRule, v) {
      let extendValues = {}
      if(valueConfigRule.unit?.length) {
        extendValues =  {
          specValue: {
            value: v?.extendValues?.specValue?.value || '',
            valueUnit: v?.extendValues?.specValue?.valueUnit || valueConfigRule.unit[0].unitPropValueName
          },
        }
      }
      // 处理度量衡相关的数据
      if(valueConfigRule?.measureTemplate) {
        const measureTemplates = valueConfigRule.measureTemplate;
        if (measureTemplates.length > 0) {
          let measureTemplate = measureTemplates[0];
          const { templateId, value: savedValue } = v?.extendValues?.kuaishouMeasureInfo || {};

          // 匹配是否存在相同的度量衡模板
          const matchTemplate = measureTemplates.find(item => item.templateId === templateId);

          if (templateId && matchTemplate) {
            // 如果找到匹配的模板，使用原有数据
            measureTemplate = matchTemplate;
            extendValues.kuaishouMeasureInfo = {
              templateId: measureTemplate.templateId,
              value: savedValue || [],
            }
          } else {
            // 未匹配到模板（非度量衡类目切换 或 数据不兼容），由当前模板初始化新数据
            const comp = measureTemplate.comp;
            const value = comp.map(item => ({
              type: item.type,
              value: item.type === 'OPERATOR' ? item.operatorRule.operatorValue : '',
              unitValueId: item.type === 'TEXT' && item.textRule?.unit?.length ? item.textRule.unit[0].unitValueId : 0,
              unitValueName: item.type === 'TEXT' && item.textRule?.unit?.length ? item.textRule.unit[0].unitValueName : '',
            }));
            extendValues.kuaishouMeasureInfo = {
              templateId: measureTemplate.templateId,
              value,
            }
          }
        }
      }
      return extendValues
    },
    
    initSelfFormSkuList(specifications) {
      this.skuList = [];
      let skuList = [];
      const oriSkuList = cloneDeep(this.self_form.skuList)
      if (oriSkuList?.length) {
        skuList = oriSkuList.map(item => {
          const skuSpecifications = item[this.skuSpecificationsKey].filter(sp => {
            if(sp.name === '发货时效') { // 去除发货时效，保存时再加上
              item.spotPresaleName = sp.value
              return false
            } 
            return true
          })
          const _skuid = skuSpecifications.map(sp => sp.valueKey).join('-')
          return {
            ...item,
            _skuid,
            [this.skuSpecificationsKey]: skuSpecifications
          }
        })
      }
      this.self_form.skuList = skuList;
    },
    spotPresaleIntoSkuList(skuList) {
      if(!this.spotPresaleList.length) {
        return skuList
      }
      skuList = cloneDeep(skuList)
      let newSkuList = []
      skuList.forEach(skuListItem => {
        const { _skuid } = skuListItem;
        this.spotPresaleList.forEach((spotPresale, spotPresaleIndex) => {
          let skuItem = {}
          const oldFindItem = this.skuList.find(sku => sku._skuid === _skuid && sku.spotPresaleName === spotPresale)
          const findItem = this.self_form.skuList.find(sku => sku._skuid === _skuid && sku.spotPresaleName === spotPresale)
          const oldSkus = this.skuList.filter(sku => sku._skuid === _skuid)
          skuItem = cloneDeep(oldFindItem || findItem || oldSkus[spotPresaleIndex] || skuListItem)
          // if(oldFindItem && findItem) {
          //   skuItem[this.skuSpecificationsKey] = cloneDeep(findItem[this.skuSpecificationsKey])
          // }
          skuItem[this.skuSpecificationsKey] = cloneDeep(skuListItem[this.skuSpecificationsKey])
          skuItem.imageUrl = skuListItem.imageUrl
          skuItem.spotPresaleName = spotPresale
          skuItem.isGray = skuListItem.isGray
          newSkuList.push(skuItem)
        })
      })
      return newSkuList
    },
    addPresellTime() {
      this.self_form.sellTimeConfig.presellTime.push('')
    },
    deletePresellTime(index) {
      this.self_form.sellTimeConfig.presellTime.splice(index, 1)
    },
    changeSell_type() {
      if(this.self_form.sellType) {
        this.self_form.sellTimeConfig.presellTime.splice(1, 1)
        let spotGoodsTime = this.self_form.sellTimeConfig.spotGoodsTime
        if(this.self_form.sellType === 3 && !spotGoodsTime && spotGoodsTime != null ){ // 没有值就设置一个默认值
          this.self_form.sellTimeConfig.spotGoodsTime =  172800
        }
        if(this.self_form.sellType === 1 && !spotGoodsTime){ // 没有值就设置一个默认值
          this.self_form.sellTimeConfig.spotGoodsTime =  172800
        }
      }
    },
    specificationUploadImg(val) {
      this.specification_needImg = val
    },
    async valid_specifications() {
      return new Promise(async (resolve, reject) => {
          if (this.$refs.specificationRef) {
              let validSpecId = await this.$refs.specificationRef.validate();
              if (!validSpecId) {
                  resolve(false);
                  return;
              }
          }
          const specificationsValid = await this.validateSpecifications();
          this.specificationsValidResult = specificationsValid;
          if (specificationsValid !== true) {
              resolve(false);
              return;
          }
          resolve(true);
      });
    },
    async valid_others() {
      if(this.$refs.BrandIdBlockRef) {
          const brandValid = await this.$refs.BrandIdBlockRef.method_validate()
          if (!brandValid) {
            return false;
          }
        }
      return true
    },
    method_getFormData(cb) {
      return new Promise(async (resolve, reject) => {
        this.validPage().then(valid => {
          if (!valid) {
            this.$message.error('请完善表单')
            resolve(false)
            return;
          }
          let [specifications, skuList] = this.getSpecificationData()
          specifications.forEach(s => {
            if(!s?.valueConfigRule?.unit?.length) {
              s.values.forEach(v => {
                delete v.extendValues.specValue
              })
            }
            delete s.salePropType
            delete s.nameConfigRule
            delete s.valueConfigRule
          })
          // 调试用，提交需注释
          // console.log([specifications, skuList], '--[specifications, skuList]--')
          // resolve(false);
          // return;
          const c_names = this.$refs.cinput.method_getCategoryNames()
          let _formdata = JSON.parse(JSON.stringify(this.self_form))
       
          if(_formdata.sellTimeConfig.presellTime) {
            _formdata.sellTimeConfig.presellTime = _formdata.sellTimeConfig.presellTime.filter(Boolean).map(time => time * 24 * 3600 ) // 转换为秒
          }
          if(_formdata.sellTimeConfig.spotGoodsTime === null){
            delete _formdata.sellTimeConfig.spotGoodsTime
          }
          let hasSkuStock = true;
          // 预售模式下校验sku库存至少有一个大于0
          if([2,3].includes(_formdata.sellType)){
            hasSkuStock = false;
            skuList.forEach(sku => {
              if(sku.skuStock > 0){
                hasSkuStock = true;
              }
            });
          }
          if(!hasSkuStock){
            this.$message.error('预售商品至少有一个sku规格库存大于0')
              return
          }
          _formdata.sellTimeConfig = JSON.stringify(_formdata.sellTimeConfig)
          _formdata.specifications = JSON.parse(JSON.stringify(specifications))
          _formdata.skuList = skuList.map(item => ({...item, imageUrl: item[this.skuSpecificationsKey][0].imageUrl}))
          _formdata.categoryId = _formdata.categoryIds[_formdata.categoryIds.length - 1]
          _formdata.categoryName = c_names[c_names.length - 1]
          _formdata.parentCategoryId = _formdata.categoryIds[_formdata.categoryIds.length - 2]
          _formdata.parentCategoryName = c_names[c_names.length - 2]
          _formdata.details = _formdata.details ? _formdata.details : _formdata.title
          _formdata.itemPropValues = this.$refs.cateprops.method_filterPreConstraintNoShow(_formdata.itemPropValues)
          _formdata.shopBrandConf = this.mergeHiddenShopData(cloneDeep(_formdata.shopBrandConf), this.originalShopBrandConf, this.shopList);
          _formdata.templateConfig = (() => {
            let current = JSON.parse(this.handleTemplateConfig());
            current = this.mergeHiddenShopData(current, this.originalTemplateConfig, this.shopList);
            return JSON.stringify(current);
          })();
          _formdata.shopId = this.shops_getCategoryPropShopId('kuaishou')
          _formdata.uploadSpecImg = this.specification_needImg; // 是否上传快手规格图片数据
          _formdata.isOnshelf = this.isOnshelf,
          resolve(_formdata)
        })
      })
    },
    updateRefundRule(categoryConfig, brandPropConfig) {
      this.brandPropConfig = brandPropConfig
      this.categoryConfig = this.$set(this, 'categoryConfig', categoryConfig);
      const servicePromises = [
          {key: 'freshRotRefund', label: '坏了包退'}, 
          {key: 'brokenRefund', label: '破损包退'}, 
          {key: 'allergyRefund', label: '过敏包退'}, 
      ];
      this.servicePromiseSelectList = servicePromises.filter(promise => {
        const configVal = categoryConfig[promise.key];
        if(configVal === undefined) return false;
        promise.disabled = false;
        if(configVal === '0') {
          promise.disabled = true;
          this.self_form.servicePromise[promise.key] = false;
        } else if(configVal === '2') {
          promise.disabled = true;
          this.self_form.servicePromise[promise.key] = true;
        }
        return true;
      })
      const newRefundRule = categoryConfig.refundRuleList || [];
      this.refundRuleOptions = refundRuleList.filter(item => newRefundRule.includes(item.value))
      if (this.self_form.refundRule && newRefundRule.includes(this.self_form.refundRule)) {
        return ;
      }
      this.self_form.refundRule = newRefundRule.length ? newRefundRule[0] : ''
      this.$nextTick(() => {
        this.validPage();
      })
    },
    updateCategoryIds(ids) {
      this.self_form.categoryIds = ids;
    },
    handleTemplateConfig() {
      const arr = [];
        Object.keys(this.shipsValue).forEach(key=> {
          this.shipsTemplate[key].forEach(item=> {
            const channel = this.shopList.find(shop => shop.id == key)?.channel
            if(item.id == this.shipsValue[key]){
                arr.push({
                  shopId: key,
                  templateId: item.id,
                  templateName: item.name,
                  channel
                })
            }
          })
        })
        return JSON.stringify(arr);
    },
    // 处理快手详情 templateConfig
    initTemplateConfig(templateList = []) {
        const ships = {};
        this.shopList.forEach((shop) => {
          ships[shop.id] = '';
        });
        const templateConfigMap = {};
        this.self_form.templateConfig = this.self_form.templateConfig ? this.self_form.templateConfig : []
        this.self_form.templateConfig.forEach(item => {
            templateConfigMap[item.shopId] = {
            templateId: item.templateId,
            templateName: item.templateName
            };
        })
        templateList.forEach(item => {
            if(!templateConfigMap[item.shopId]){
                templateConfigMap[item.shopId] = {
                templateId: item.templateId,
                templateName: item.templateName
            };
            }
        })
        this.templateConfigMap = templateConfigMap;
        Object.keys(templateConfigMap).forEach(key => {
          ships[key] = templateConfigMap[key].templateId
        })
        this.shipsValue = ships;
        this.initShipsTemplate(templateConfigMap);
        },
        // 处理每个店铺下拉框
        initShipsTemplate(templateConfigMap) {
        const shipsTemplate = {};
        this.shopList.forEach(shop => {
            shipsTemplate[shop.id] = []
        });
        Object.keys(templateConfigMap).forEach(key=> {
            shipsTemplate[key] = [{
            id: templateConfigMap[key].templateId || '',
            name: templateConfigMap[key].templateName || ''
            }]
        })
        this.shipsTemplate = shipsTemplate;
        },
        // 获取配置
        async getConf() {
          const res = await getDistributionConfig({shopType: 'KWaiShop'});
          // 上架设置
          this.isOnshelf = this.self_form.isOnshelf ? this.self_form.isOnshelf : (res?.shelfState || 1);

          // 运费模板
           this.initTemplateConfig(res?.templateList || []);
           this.autoCropImageConfigList = res.autoCropImageConfigList ? res.autoCropImageConfigList : [];
            if(this.autoCropImageConfigList.length){// 异步获取到不用校验图片尺寸的情况，重新校验一下刷新状态
                setTimeout(() => {
                    this.validPage();
                }, 3000)
            }
        },
        // 获取模板
        async getTemplateList(userId) {
        const list = await getKSTemplateList({
          offset: 0,
          limit: 100,
          searchUsed: false,
          userId: userId
        });
        if (list) {
            return list.map(ship => {
                return {
                    name: ship.name,
                    id: ship.id.toString()
                }
            });
        }
        return [];
        },
        async changeSelect(shopId, userId) {
          const list = await this.getTemplateList(userId);
          const idx = list.findIndex(item => item.id === this.shipsValue[shopId]);
          if (idx === -1) {
              this.shipsValue[shopId] = '';
          }
          this.$set(this.shipsTemplate, shopId, list);
        },
        useGroupImages(data, type) {
          const {mainImages=[], detailImages=[], speImages=[]} = data
          const groupMainImages34 = data?.mainImages34 || []
          let pic = [], description = [], mainImages34 = [];
          if(type === 'add') {
            pic = [...this.self_form.imageUrls].filter(Boolean)
            mainImages34 = [...this.self_form.mainImages34].filter(Boolean)
            description = [...this.self_form.detailImageUrls]
          }
          if(mainImages.length) {
            this.self_form.imageUrls = [...pic, ...mainImages].filter(Boolean).slice(0, 9)
          }
          if(groupMainImages34.length) {
            this.self_form.mainImages34 = [...mainImages34, ...groupMainImages34].slice(0, 5)
          }
          if(detailImages.length) {
            this.self_form.detailImageUrls = [...description, ...detailImages].filter(Boolean).slice(0, 50)
          }

          const firstSpec = this.specifications[0];
          if (firstSpec && firstSpec.values && speImages.length) {
            firstSpec.values.forEach(specValue => {
              // 如果是新增模式且已有图片，则跳过
              if (type === 'add' && specValue.imageUrl) {
                return;
              }
              
              // 查找匹配的图片
              const matchedImage = speImages.find(img => img.name === specValue.value);
              if (matchedImage) {
                specValue.imageUrl = matchedImage.imgUrl;
              }
            });
          }
        },
        getGroupImagesList (list){
          this.showGroupImages = !!list?.length
        },
        editGroupImages(){
          this.changeToBase('openGroupImgs')
        },
        clickTemPlateFill(row) {
          const platformCatProp = row.platformCatProp ? JSON.parse(row.platformCatProp) : []
          this.self_form.itemPropValues = platformCatProp
        },
        getTableCols(){
          let openSource = this.openSource
          let isShowPreviewPrice = true;
          if(['taskCenter','previewPublish'].includes(openSource)){
              isShowPreviewPrice = false
          }
          const skuTableCols = [
              {prop: 'spotPresaleName', attrs: {label: '发货时效'}, unvisible: true },
              {prop: 'skuSalePrice', attrs: {label: '价格'}, input: {
                type: 'number', validator: validateSkuPrice,
              }, previewPrice: isShowPreviewPrice},
              {
                  prop: 'skuSupplyPrice', attrs: { label: '供货价',noRequired: true }, unvisible:JSON.parse(localStorage.getItem('_origin_form'))?.isDistribution == 0? true : false 
              },
              {
                prop: 'skuStock',
                attrs: {label: '库存'},
                input: {
                  type: 'number',
                  disabled:false,
                  attrs: { precision: 0}
                },
                disabledFn:(row)=>{
                  return row.stockType == 1
                }
              },
              this.openSource != 'shopGoods' ? {prop: 'skuNick', attrs: {label: '商家编码', noRequired: this.isGroupPuhuo}} : null,
          ]
          this.skuTableCols = skuTableCols.filter(Boolean)
        },
        // 商品视频
        async handleVideo(value, type) {
          // type 0 删除 1 成功
          this.self_form.videoVo = type === 1 ? { ...value } : null;
          this.self_form.videoId = null;
          this.self_form.videoUrl = ''
          if(this.self_form.videoVo) {
            const result = await editKuaishouCarouselVideo({
              carouselVideoVo: this.self_form.videoVo,
              baseItemId: this.baseItemId
            });
            const { data: videoId = null } = result || {};
            this.self_form.videoUrl = value.originUrl
            this.self_form.videoId = videoId
          }
        },
  },
  mounted() {
    this.getConf()
    this.getTableCols()
  },
};
</script>

<style lang="scss" scope>
.platform-info-edit-wrp {
  &.is-disabled {
    pointer-events: none;
    opacity: 0.6;
    * {
      pointer-events: none;
    }
  }
}
</style>